const utils = require('../../../lib/utils');

module.exports = {
	model: {
		values: {

		}
	},

	events: {
		change: function(event){
			event.stopImmediatePropagation();
			event.preventDefault();
			var target, $target, fieldCode;
			var self = event.data.component;
			if(
				(target = event.originalEvent ? event.originalEvent.target : event.target) &&
				($target = $(target)).length > 0 &&
				(fieldCode = $target.data('fieldCode'))
			){
				// set model values according to the given fieldCode and its value
				self.triggerClosest('onChildChanged', {
					fieldCode: 	fieldCode,
					value: 		(self.model.values[fieldCode] = $target.val())
				});
			}
		}
	},

	methods: {
		prepare: function(){
			this.model.isDisabled = false;
			this.model.isFilterFieldisFilterField = false;
			if((this.formMapping || {}).fieldConfig) {
				this.model.isDisabled 		= (this.formMapping.fieldConfig || {}).disabled;
				this.model.isFilterField   	= (this.formMapping.fieldConfig || {}).isFilterField;
			}

			this.model.dataFlag = 'dataTEXT';
			if(this.model.atom.dataType === 'integer'){
				this.model.dataFlag = 'dataINT';
			}

			// build options for months
			var tmp;
			var m;
			var monthOptions = [{
				name: '-',
				value: null
			}];
			for (m=1; m<=12; m++) {
				tmp = "_0" + m;
				tmp = tmp.substr(tmp.length - 2,tmp.length);
				monthOptions.push({
					name: tmp,
					value: tmp
				});
			}
			this.model.monthFieldData = {
				model: utils.replace(this.model, { fieldCode: this.model.fieldCode + 'Month', 'text-data': monthOptions }),
				formMapping: this.formMapping
			};

			// build options for years
			var curDate = new Date();
			var curYear = curDate.getFullYear();
			var yearOptions = [{
				name: '-',
				value: null
			}];
			var y;
			for (y=curYear; y<=(curYear+10); y++) {
				yearOptions.push({
					name: y,
					value: y
				});
			}
			this.model.yearFieldData = {
				model: utils.replace(this.model, { fieldCode: this.model.fieldCode + 'Year', 'text-data': yearOptions }),
				formMapping: this.formMapping
			};
		},

		setDefaultValue: function(){
			if(this.model.values[this.model.fieldCode + 'Month'] === undefined){
				this.triggerClosest('onChildChanged', {
					fieldCode: 	this.model.fieldCode + 'Month',
					value: 		1
				});
			}
			if(this.model.values[this.model.fieldCode + 'Year'] === undefined){
				this.triggerClosest('onChildChanged', {
					fieldCode: 	this.model.fieldCode + 'Year',
					value: 		(new Date()).getFullYear()
				});
			}
		}
	}
};